import React from 'react';
import {CMSLandingVideoCarousel} from '@tempo/landing';
import {Box} from '@tempo/core';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiCarouselBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiVideoCarouselBlock: React.FC<StrapiCarouselBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<Box
			bg="background.neutral.primary.default"
			py="spacing.xl"
			maxWidth={{base: '100%', md: '1440px'}}
			mx="auto"
		>
			<CMSLandingVideoCarousel
				items={strapiBlockData.video.map((v: any) => ({
					title: resolve(v.title).replace(/<[^>]+>/g, ''),
					src: v.src?.url ?? v.srcUrl ?? '',
					description: resolve(v.description).replace(/<[^>]+>/g, ''),
					placeholder: v.placeholder ? v.placeholder.url : undefined,
					alt: resolve(v.alt).replace(/<[^>]+>/g, ''),
				}))}
				autoPlay={true}
			/>
		</Box>
	);
};
